import { useTranslation } from "react-i18next";

const REVIEWS = [
  { name: "Silvia Jaqueline Delgado", key: "reviews.r1" },
  { name: "Nadia Schiera", key: "reviews.r2" },
  { name: "Alejandra Marichal", key: "reviews.r3" },
  { name: "Bruno Ferreyra", key: "reviews.r4" },
  { name: "Florencia Rossi", key: "reviews.r5" },
  { name: "Romina Baudo", key: "reviews.r6" },
  { name: "Eduardo Fayos", key: "reviews.r7" },
  { name: "Alison Pazos", key: "reviews.r8" },
];

const STARS = [0, 1, 2, 3, 4];

export default function Reviews() {
  const { t } = useTranslation();

  return (
    <section className="reviews-section" id="reviews" aria-label={t("reviews.nav")}>
      <div className="reviews-inner">
        <div className="reviews-head">
          <p className="stamp mono" data-reveal>
            {t("reviews.stamp")}
          </p>
          <h2
            data-reveal
            dangerouslySetInnerHTML={{ __html: t("reviews.h2") }}
          />
          <p className="reviews-sub" data-reveal>
            {t("reviews.sub")}
          </p>
        </div>

        <div className="reviews-grid">
          <div className="review-card review-score" data-reveal>
            <div className="flex items-baseline gap-2">
              <span className="score-figure">{t("reviews.score")}</span>
              <div className="flex items-center gap-[3px] score-stars" aria-hidden="true">
                {STARS.map((s) => (
                  <i key={s} className="ri-star-fill text-[13px]" />
                ))}
              </div>
            </div>
            <p className="score-cap">{t("reviews.scoreCap")}</p>
            <p className="score-count">{t("reviews.count")}</p>
            <span className="score-badge">
              <i className="ri-google-fill text-[15px]" aria-hidden="true" />
              Google
            </span>
          </div>

          {REVIEWS.map((r) => (
            <article className="review-card" key={r.key} data-reveal>
              <div className="flex items-center gap-[3px] review-stars" aria-label={t("reviews.starsLabel")}>
                {STARS.map((s) => (
                  <i key={s} className="ri-star-fill text-[12.5px]" aria-hidden="true" />
                ))}
              </div>
              <p className="review-text">{t(r.key)}</p>
              <div className="review-foot">
                <span className="review-name">{r.name}</span>
                <span className="review-meta mono">{t("reviews.date")}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}